export function isSingleOnlyCard(card) {
  return (
    card.computed.pantheon_only ||
    card.types.some((t) => t === "REGALIA" || t === "CHAMPION")
  )
}
